module.exports = __webpack_public_path__ + "static/media/JustActMailers_MSME Part 2-01.1e8c2237.png";